import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../components/ui/Section';
import { CTASection } from '../components/sections/CTASection';
import { ArrowUpRight } from 'lucide-react';
export function WorkPage() {
  const projects = [{
    title: 'FinTech Dashboard',
    category: 'Product Design',
    description: 'A comprehensive financial management platform with real-time analytics and intuitive data visualization.',
    tags: ['UI/UX', 'Dashboard', 'Data Viz'],
    color: 'bg-blue-50'
  }, {
    title: 'E-commerce Platform',
    category: 'Web Development',
    description: 'A modern, high-converting online store with seamless checkout experience and inventory management.',
    tags: ['E-commerce', 'React', 'Stripe'],
    color: 'bg-amber-50'
  }, {
    title: 'Health & Wellness App',
    category: 'Mobile Design',
    description: 'A wellness tracking application focused on mental health, meditation, and daily habit building.',
    tags: ['Mobile', 'iOS', 'Android'],
    color: 'bg-green-50'
  }, {
    title: 'SaaS Marketing Site',
    category: 'Brand & Web',
    description: 'Complete brand identity and marketing website for a B2B software company.',
    tags: ['Branding', 'Marketing', 'Web'],
    color: 'bg-purple-50'
  }, {
    title: 'Real Estate Platform',
    category: 'Product Design',
    description: 'Property listing and management platform with virtual tour integration and lead management.',
    tags: ['UI/UX', 'Maps', 'Search'],
    color: 'bg-rose-50'
  }, {
    title: 'EdTech Learning Portal',
    category: 'Web Development',
    description: 'Interactive learning management system with video courses, quizzes, and progress tracking.',
    tags: ['LMS', 'Video', 'React'],
    color: 'bg-cyan-50'
  }];
  return <main className="pt-24" data-id="element-474">
      {/* Hero */}
      <Section background="default" data-id="element-475">
        <div className="max-w-4xl" data-id="element-476">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-[#0C0C0C] mb-6 leading-tight" data-id="element-477">
            Selected Work
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600 leading-relaxed" data-id="element-478">
            A collection of digital products, platforms, and experiences we've
            crafted for our clients.
          </motion.p>
        </div>
      </Section>

      {/* Projects Grid */}
      <Section background="white" data-id="element-479">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-480">
          {projects.map((project, index) => <motion.article key={project.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group cursor-pointer" data-id="element-481">
              <div className={`aspect-[4/3] rounded-xl overflow-hidden mb-6 ${project.color} relative`} data-id="element-482">
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-483">
                  {/* Placeholder visual */}
                  <div className="w-3/4 h-3/4 bg-white/50 rounded-lg shadow-lg flex items-center justify-center" data-id="element-484">
                    <span className="text-gray-400 text-sm" data-id="element-485">
                      Project Preview
                    </span>
                  </div>
                </div>
                <div className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-md" data-id="element-486">
                  <ArrowUpRight className="w-5 h-5 text-[#0C0C0C]" data-id="element-487" />
                </div>
              </div>

              <div className="flex items-start justify-between mb-3" data-id="element-488">
                <div data-id="element-489">
                  <h2 className="text-2xl font-bold font-heading text-[#0C0C0C] group-hover:text-[#00316B] transition-colors" data-id="element-490">
                    {project.title}
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-491">{project.category}</p>
                </div>
              </div>

              <p className="text-gray-600 mb-4 leading-relaxed" data-id="element-492">
                {project.description}
              </p>

              <div className="flex flex-wrap gap-2" data-id="element-493">
                {project.tags.map(tag => <span key={tag} className="px-3 py-1 bg-gray-100 text-gray-600 text-xs rounded-full" data-id="element-494">
                    {tag}
                  </span>)}
              </div>
            </motion.article>)}
        </div>
      </Section>

      <CTASection data-id="element-495" />
    </main>;
}